import Colors from '@digili-ui/constants/colors'
import { JSX, PropsWithChildren } from 'react'
import styled from 'styled-components'

import { Button } from '../actions/Button'
import { LogoIconType } from '../global/ComponentProps'
import { MAIN_HEADER_HEIGHT, PAGE_COMPONENT_GAP } from '../global/constants'
import { SimplePageContentSection } from '../global/LayoutStyling'
import { SPACE_SMALL, SPACE_XLARGE } from '../global/spacing'
import { ChangeLanguageButtonOptions, PrimaryTopBarActionButtonOptions } from '../navigation/PrimaryTopBar'
import { PrimaryTopBar } from '../navigation/PrimaryTopBar/PrimaryTopBar'
import { PrimaryHeading } from '../typography/headings/PrimaryHeading'
import { WideContainer } from './WideContainer'

interface CatalogStepProps {
  actionBarOptions?: { label: string; onClick: () => void; icon: JSX.Element }
  actionButtonOptions: PrimaryTopBarActionButtonOptions
  changeLanguageOptions?: ChangeLanguageButtonOptions
  displayName?: string | undefined
  header: string
  ['data-testid']?: string
}

const PageContainer = styled(SimplePageContentSection)`
  padding-bottom: 52px;
  align-items: flex-start;
  padding: 0 ${SPACE_SMALL} 52px ${SPACE_SMALL};
`

const PageContent = styled.div`
  display: grid;
  gap: ${PAGE_COMPONENT_GAP}px;
  margin-top: ${SPACE_XLARGE};
`

const ActionBarWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
  align-items: center;
  height: ${MAIN_HEADER_HEIGHT}px;
`

export const CatalogStep = ({
  actionBarOptions,
  actionButtonOptions,
  changeLanguageOptions,
  children,
  displayName,
  header,
  'data-testid': dataTestId,
}: PropsWithChildren<CatalogStepProps>): JSX.Element => {
  return (
    <WideContainer data-testid={dataTestId}>
      <PrimaryTopBar
        actionButtonOptions={actionButtonOptions}
        bottomBorder={false}
        changeLanguageButtonOptions={changeLanguageOptions}
        icon={LogoIconType.SPankki}
        userDisplayName={displayName}
      />
      <PageContainer $backgroundColor={Colors.BackgroundDefaultNeutral}>
        {actionBarOptions && (
          <ActionBarWrapper>
            <Button
              label={actionBarOptions.label}
              icon={actionBarOptions.icon}
              compact={true}
              variant={'plain'}
              color={'neutral'}
              onClick={actionBarOptions.onClick}
            />
          </ActionBarWrapper>
        )}
        <PageContent>
          <PrimaryHeading header={header} />
          {children}
        </PageContent>
      </PageContainer>
    </WideContainer>
  )
}
